export const augmentLocations = (locations, currentLocation = null) => {
  if (!locations) {
    return [];
  }

  const augmented = locations.map((location) => {
    const locToken = location.localization_key ||
      `responses.encounter_${location.type}.${location.description}.title`;

    let selected = false;
    let parent = null;

    if (currentLocation) {
      const { locations, ...rest } = currentLocation;
      parent = rest; // omit the child locations

      /*
      This logic for toggling the .selected value works due to the way we have constructed the selection flow but it is a bit hard to understand just by looking at it.

      The UI starts out displaying all the root locations and currentLocation will be null so .selected will be false for all initial root locations.

      When the user makes a selection, that updates the state.current data to be the item chosen but does not immediately call the childLocations method so that set of locations in view remains the root locations. .selected will work properly because the current selection is among the set in view.

      The set of locations in view gets updated on navigation (as part of vue lifecycle trigger) and will then property display the childLocations of the previously selected location. Once a selection is made from among that set of locations, the state.current is updated again and .selected will function properly.
      */
      selected = currentLocation.value === location.value;
    }

    return {
      ...location,
      parent,
      selected,
      token: locToken,
      value: location.name,
    };
  });

  return augmented;
}

const buildResponses = (location, responses) => {
  if(!location) {
    return responses;
  }

  const { id, name, description, selected, type, token, value } = location;

  const key = `encounter_${type}`;
  responses[key] = {
    id,
    name,
    description,
    selected,
    token,
    value,
    location_type: type,
    panel: key,
    panel_input: 'multiselect',
    panel_type: 'select',
  };

  return buildResponses(location.parent, responses);
}

export default {
  /*
  Child locations of the currently selected location augmented with additional properties
  */
  childLocations: (state) => {
    if (!state.current) {
      return [];
    }

    return augmentLocations(state.current.locations, state.current);
  },

  /*
  The currently selected location without child locations
  */
  current: (state) => {
    if (!state.current) {
      return null;
    }

    const { locations, ...rest } = state.current;

    return rest;
  },

  /*
  Finalized location selection data formatted for bundeling
  */
  responses: (state) => {
    return buildResponses(state.current, {});
  },

  /*
  Top level locations or location groups. Where to start selecting from.
  */
  rootLocations: (state, getters, rootState) => {
    return rootState?.settings?.locations || [];
  },

  /*
  Boolean to indicate that no further location selections are necessary.
  i.e. the most specific or leaf node location has been selected.
  */
  selectionsComplete: (state) => {
    return !!state.current && !state.current?.locations;
  },

  /*
  Formatted for preferences summary panel
  */
  summary: (state, getters) => {
    let summary = null;

    if (state.current) {
      const responseValues = Object.values(getters.responses);

      summary = {
        collections: 'location',
        editRoutePath: '/location',
        id: 0,
        name: 'locations',
        responses: responseValues,
        type: 'location',
      };
    }

    return summary;
  }
}
